import { BaseQueryFn, createApi } from '@reduxjs/toolkit/query/react';
import axios, { AxiosRequestConfig } from 'axios';
import { TagType } from 'common/enums/api.enums';
import { snackbar } from 'common/utils/snackbarUtils';
import { getArray } from 'common/utils/typeUtils';
import { FormattedMessageByCode, ServerError } from 'common/errors/serverErrors';

type BaseQueryArgs = {
  url: string;
  method?: AxiosRequestConfig['method'];
  data?: AxiosRequestConfig['data'];
  params?: AxiosRequestConfig['params'];
  headers?: AxiosRequestConfig['headers'];
};

const axiosBaseQuery = (baseUrl: string = ''): BaseQueryFn<BaseQueryArgs> => {
  return async ({ url, method, data, params, headers }) => {
    try {
      const result = await axios({
        url: baseUrl + url,
        method,
        data,
        params,
        headers,
      });

      return { data: result };
    } catch (error) {
      const isCanceled = !!error.codes?.includes(ServerError.CANCELED);

      if (!isCanceled) {
        const codes = getArray<string>(error?.codes);

        for (const code of codes) {
          const msg = FormattedMessageByCode(code);

          if (msg) {
            snackbar.error(msg);
          }
        }
      }

      return { error };
    }
  };
};

const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery(process.env.REACT_APP_API_URL),
  tagTypes: Object.values(TagType),
  keepUnusedDataFor: 10,
  endpoints: () => ({}),
});

export default baseApi;
